import script from "./IssueUploaderLicenseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueUploaderLicenseModal.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/admin.css?vue&type=style&index=0&id=27f76950&scoped=true&lang=css&external"
import "./IssueUploaderLicenseModal.vue?vue&type=style&index=1&id=27f76950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f76950"]])

export default __exports__